import React from 'react';
import { Link } from 'react-router-dom';
import NeoCard from '../../../../../components/Common/NeoCard';
import NeoButton from '../../../../../components/Common/NeoButton';

const formatWhatsAppNumber = (phone) => {
    if (!phone) return null;
    return phone.replace(/\D/g, '');
};

const SidebarMemberInfo = ({ item, onClose }) => {
    if (!item?.memberNumber) return null;

    return (
        <div className="mb-4">
            <h6 className="text-uppercase font-size-11 fw-bold text-brand-secondary mb-2">
                <i className="mdi mdi-account-star-outline me-1"></i>
                Cliente Vinculado
            </h6>
            <NeoCard thinBorder={true} bodyClassName="p-3 d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center overflow-hidden">
                    <div className="me-3 flex-shrink-0" style={{ width: '42px', height: '42px' }}>
                        {item.memberPhotoUrl ? (
                            <img 
                                src={item.memberPhotoUrl} 
                                alt="Cliente" 
                                className="rounded-circle" 
                                style={{ width: '42px', height: '42px', objectFit: 'cover' }} 
                            />
                        ) : (
                            <div 
                                className="rounded-circle d-flex align-items-center justify-content-center bg-light border font-size-16 fw-bold text-brand-primary" 
                                style={{ width: '42px', height: '42px' }}
                            >
                                {(item.memberName?.charAt(0) || 'C').toUpperCase()}
                            </div>
                        )}
                    </div>
                    <div className="overflow-hidden">
                        <h6 className="text-truncate mb-0 fw-bold text-brand-primary font-size-14">
                            {item.memberName || 'Cliente'}
                        </h6>
                        {item.memberPhone && <p className="text-truncate mb-0 text-muted font-size-12">{item.memberPhone}</p>}
                        {item.memberEmail && <p className="text-truncate mb-0 text-muted font-size-12">{item.memberEmail}</p>}
                    </div>
                </div>
                <div className="d-flex gap-2 flex-shrink-0 ms-2">
                    <NeoButton
                        variant="chocolate"
                        circle={true}
                        size="sm"
                        icon="mdi-eye-outline"
                        tag={Link}
                        to={`/members/${item.idMember || item.memberNumber}`}
                        title="Acessar Ficha do Cliente"
                        onClick={onClose}
                    />
                    {item.memberPhone && (
                        <NeoButton
                            variant="success"
                            circle={true}
                            size="sm"
                            icon="mdi-whatsapp"
                            href={`https://wa.me/55${formatWhatsAppNumber(item.memberPhone)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Enviar Mensagem no WhatsApp"
                        />
                    )}
                </div>
            </NeoCard>
        </div>
    );
};

export default SidebarMemberInfo;
